/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpSharedContactSupportButton_item$ref: FragmentReference;
export type PdpSharedContactSupportButton_item = {|
  +dibsReference: ?string,
  +$refType: PdpSharedContactSupportButton_item$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpSharedContactSupportButton_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "dibsReference",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'fa7fd05e2a569986cf3fe8707f915d6a';
module.exports = node;
